/**
 * Usage Configuration for Caps
 */

import { supabase } from '../../../../../supabaseClient';

export const usageCapConfig = {
  type: 'caps',
  displayName: 'Caps',
  singularName: 'Cap',
  itemIdField: 'cap_id',
  itemNameField: 'name',
  
  // Database tables
  inventoryTable: 'caps_inventory',
  itemsTable: 'caps_inventory_items',
  transactionsTable: 'caps_transactions',
  
  // Get available inventory items for a location
  getInventoryItems: async (companyId, itemId, locationId) => {
    const { data, error } = await supabase
      .from('caps_inventory_items')
      .select('*')
      .eq('company_id', companyId)
      .eq('cap_id', itemId)
      .eq('location_id', locationId)
      .eq('is_active', true)
      .gt('current_quantity', 0)
      .order('created_at', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },
  
  // Execute usage transaction
  executeUsage: async (companyId, usageData) => {
    const { locationId, usages, notes } = usageData;
    
    // Process each usage item
    for (const usage of usages) {
      const { itemId, lotId, quantity, lot_number, batch_number } = usage;
      
      // Only create transaction - DB triggers will handle inventory updates
      const { error: txError } = await supabase
        .from('caps_transactions')
        .insert([{
          company_id: companyId,
          cap_id: itemId,
          transaction_type: 'usage',
          quantity: -Math.abs(quantity), // Negative for usage
          location_id: locationId,
          lot_number: lot_number,
          batch_number: batch_number,
          transaction_date: new Date().toISOString(),
          notes: notes || null,
          delivery_status: 'delivered'
        }]);
      
      if (txError) throw txError;
    }
  }
};
